import { Link } from '@tanstack/react-router'
import { Menu, Sparkles, X } from 'lucide-react'
import { useState } from 'react'
import { Button } from './ui/button'

export function LogicNextNavbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <>
      <nav className="fixed top-6 left-0 right-0 z-50 mx-auto max-w-5xl px-4">
        <div className="relative rounded-full border border-white/10 bg-slate-950/70 shadow-2xl backdrop-blur-xl transition-all duration-300 hover:border-white/20">
          <div className="flex h-12 items-center justify-between pl-6 pr-2">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2 group">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-linear-to-br from-indigo-500 to-blue-600 transition-transform group-hover:scale-110">
                <Sparkles className="h-4 w-4 text-white" />
              </div>
              <span className="text-lg font-bold tracking-tight text-white">
                LogicNext
              </span>
            </Link>

            {/* Desktop Links */}
            <div className="hidden md:flex items-center gap-8">
              <NavLinks />
            </div>

            {/* CTA */}
            <div className="hidden md:flex items-center gap-3">
              <Button
                asChild
                size="sm"
                className="rounded-full bg-white text-slate-950 hover:bg-slate-200"
              >
                <Link to="/contact">Book Free Consultation</Link>
              </Button>
            </div>

            {/* Mobile Menu Toggle */}
            <button
              className="md:hidden text-slate-300 hover:text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-slate-950/95 backdrop-blur-md pt-28 px-6 md:hidden animate-in fade-in slide-in-from-top-10">
          <div className="flex flex-col gap-6 text-lg">
            <NavLinks mobile />
            <div className="h-px bg-white/10 my-4" />
            <Button
              asChild
              className="w-full justify-center bg-indigo-600 hover:bg-indigo-700 text-white"
            >
              <Link to="/contact">Book Free Consultation</Link>
            </Button>
          </div>
        </div>
      )}
    </>
  )
}

function NavLinks({ mobile }: { mobile?: boolean }) {
  const baseStyles =
    'text-sm font-medium transition-colors hover:text-indigo-400'
  const mobileStyles = 'text-xl font-medium py-2 text-slate-300'
  const styles = mobile ? mobileStyles : `${baseStyles} text-slate-300`

  return (
    <>
      <Link
        to="/solutions"
        className={styles}
        activeProps={{ className: 'text-white font-semibold' }}
      >
        Solutions
      </Link>
      <Link
        to="/pricing"
        className={styles}
        activeProps={{ className: 'text-white font-semibold' }}
      >
        Pricing
      </Link>
      <Link
        to="/testimonials"
        className={styles}
        activeProps={{ className: 'text-white font-semibold' }}
      >
        Testimonials
      </Link>
      <Link
        to="/about"
        className={styles}
        activeProps={{ className: 'text-white font-semibold' }}
      >
        About
      </Link>
    </>
  )
}
